import {createProjectModel} from 'company-management/utils/project-model'
import {
    companies,
    agentInfo,
    updateAgentInfo,
    weWorkSetting,
    updateWeWorkSetting,
    menuTree,
    updateCompany,
    updateCreator,
    addCompany,
} from '../services/company-management'

const model = createProjectModel({
    projectNamespace: 'companyManagement',

    state: {
        tableData: {},
        menuTree: [],
    },

    effects: {
        *companies(_, {select, call, put}) {
            const {tableData} = yield select((allState) => allState[model.namespace])

            const newParams = {
                offset: tableData.pagination.pageSize * (tableData.pagination.current - 1),
                limit: tableData.pagination.pageSize,
                ...tableData.params,
            }

            const res = yield call(companies, newParams)

            yield put({
                type: 'immerCb',
                payload: (draft) => {
                    draft.tableData.dataSource = res.data
                    draft.tableData.pagination.total = res?.pagination?.rows_found || 0
                },
            })
        },
        *agentInfo({payload}, {call}) {
            return yield call(agentInfo, payload)
        },
        *updateAgentInfo({payload}, {call}) {
            return yield call(updateAgentInfo, payload)
        },
        *weWorkSetting({payload}, {call}) {
            return yield call(weWorkSetting, payload)
        },
        *updateWeWorkSetting({payload}, {call}) {
            return yield call(updateWeWorkSetting, payload)
        },
        *menuTree({payload}, {call, put}) {
            const res = yield call(menuTree, payload)
            yield put({
                type: 'setProperty',
                payload: {
                    menuTree: res?.data || [],
                },
            })
            return res
        },
        *updateCompany({payload}, {call}) {
            return yield call(updateCompany, payload)
        },
        *updateCreator({payload}, {call}) {
            return yield call(updateCreator, payload)
        },
        *addCompany({payload}, {call}) {
            return yield call(addCompany, payload)
        },
    },

    reducers: {},
})

export default model
